class DuepayBalanceCart extends HTMLElement {
  connectedCallback() {
    // Escuta atualizações do saldo
    document.addEventListener('duepay:balance-updated', (e) => {
      this.updateDisplay(e.detail);
    });
    
    // Atualiza na inicialização após um pequeno delay
    setTimeout(() => {
      const balanceBar = document.querySelector('duepay-balance-bar');
      if (balanceBar && balanceBar.updateCartDisplay) {
        balanceBar.updateCartDisplay(true);
      }
    }, 100);
  }

  formatMoney(value) {
    if (value === null || value === undefined) return 'R$ 0,00';
    return `R$ ${value.toFixed(2).replace('.', ',')}`;
  }

  formatMoneyWithHighlight(value, isExceeded = false) {
    const formatted = this.formatMoney(value);
    const exceededClass = isExceeded ? ' duepay-balance-bar__value--exceeded' : '';
    if (isExceeded) {
      return `<span class="duepay-balance-bar__value${exceededClass}">${formatted}</span>`;
    }
    const valueOnly = formatted.replace('R$ ', '');
    return `R$ <span class="duepay-balance-bar__value${exceededClass}">${valueOnly}</span>`;
  }

  updateDisplay(balanceInfo) {
    const valueEl = this.querySelector('[data-balance-cart-value]');
    const labelEl = this.querySelector('.duepay-balance-cart__label');
    
    if (!valueEl || !balanceInfo?.type) {
      this.style.display = 'none';
      return;
    }

    // Busca saldos do localStorage
    const balanceKey = balanceInfo.type.toLowerCase();
    const storageKey = balanceKey === 'uniforme' ? 'duepay_balance_uniforme' : 'duepay_balance_material';
    const stored = localStorage.getItem(storageKey);
    const totalBalance = stored ? parseFloat(stored) : null;

    if (!totalBalance || totalBalance <= 0) {
      this.style.display = 'none';
      return;
    }

    this.style.display = 'block';
    const available = balanceInfo.available !== null ? balanceInfo.available : totalBalance;
    const isExceeded = balanceInfo.isExceeded || false;
    
    // Atualiza o label se existir e o valor foi excedido
    if (labelEl) {
      if (isExceeded) {
        labelEl.textContent = 'Você excedeu o valor informado';
      } else {
        labelEl.textContent = 'SALDO RESTANTE PARA USO:';
      }
    }
    
    valueEl.innerHTML = this.formatMoneyWithHighlight(available, isExceeded);
  }
}

customElements.define('duepay-balance-cart', DuepayBalanceCart);

